<template>
  <relatorio-gestao titulo="Painel de Informações" :gerarRelatorio="gerarRelatorio" :loading="loading" :pdfData="pdfData">
    <b-row>
      <b-col cols="6" xl="2">
        <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio" label-class="text-left">
          <b-form-select id="input-exercicio" v-model="filtros.exercicio" :options="exercicios">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="6" xl="2">
        <b-form-group id="input-group-mes" label="Mês *" label-for="input-mes" label-class="text-left">
          <b-form-select id="input-mes" v-model="filtros.mes" :options="meses">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </relatorio-gestao>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'
import { UtilsTS } from '@/utilsts'

import RelatorioGestao from '@/components/RelatorioGestao.vue'
import reportService from '@/services/reportService'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'
import { SelectValue } from '@/types/select-value'

const CompProps = Vue.extend({
  name: 'RelatorioGestaoEduPainelInfo',
  components: { RelatorioGestao },
})

@Component
export default class RelatorioGestaoEduPainelInfo extends mixins(UtilsTS, CompProps) {
  pdfData: any = ''
  exercicios: string[] = []
  meses: SelectValue[] = []
  loading = false
  filtros: FiltrosGestao = new FiltrosGestao()

  async gerarRelatorio(): Promise<void> {
    try {
      this.pdfData = '';
      this.loading = true;
      if (this.validarFiltros()) {
        const response = await reportService.getRelatorioGestao('EducacaoPainelInformacoes', this.filtros)
        this.pdfData = response.ArquivoPdf
      }
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.loading = false;
    }
  }

  validarFiltros(): boolean {
    if (!this.filtros.exercicio || this.filtros.exercicio < 2023) {
      this.$toast.error('Exercício é obrigatório')
      return false
    }
    if (!this.filtros.mes || this.filtros.mes < 1 || this.filtros.mes > 12) {
      this.$toast.error('Mês é obrigatório')
      return false
    }
    return true
  }

  async mounted() {
    this.exercicios = this.getListaAnos2023ateAnoAtual()
    this.meses = this.getListaMeses()
    this.filtros.exercicio = new Date().getFullYear();
    this.filtros.mes = 1
  }
}
</script>